import { Button, Text } from '@youversion/design-system-components';
import Spinner from '@youversion/design-system-icons/lib/Spinner';
import { useTranslation } from 'next-i18next';
import { firebaseLogEvent } from 'utils/firebase';

import { useGetHistoryQuery } from '@/graphql/history';

import { ListItem } from './ListItem';

interface Props {
  onClose: () => void;
  selectedYear: number;
}

export function HistoryList({ onClose, selectedYear }: Props) {
  const { t } = useTranslation('common');

  const { data: historyData, isLoading } = useGetHistoryQuery(
    { historyYear: selectedYear },
    { select: data => data?.getHistory?.data ?? [] }
  );

  if (isLoading) {
    return <Spinner className='m-auto text-text-light dark:text-text-dark' dur={0.9} size='48' />;
  }

  if (historyData?.length) {
    return <>{historyData?.map(item => <ListItem item={item} key={item.paymentDate} onClose={onClose} />)}</>;
  }

  return (
    <div className='m-auto pli-1'>
      <Text className='pli-4 text-center'>{t('giving.messages.no_data_giving_history')}</Text>
      <Button
        className='mbs-6 max-w-full justify-center'
        onClick={async () => {
          await firebaseLogEvent('GivingButtonTap', { label: 'Give Now', screen: 'giving_history' });
          onClose();
        }}
        variant='secondary'
      >
        {t('giving.cta.give_now')}
      </Button>
    </div>
  );
}
